import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    cognito:{
      userPool:null,
    },
    currentUser:{
      authenticated:false,
    },

    userProfile:{
      name:"",
      userId:0,
    },

    processings:{     
      rootGroupTree:[     
      ],       
      groups:[],
      groupMap:{},      
      processMap:{},
    },

    materials:[
      {
        materialCd:"",materialName:""
      }
    ],
    materialMap:{
      "dummy":{
        materialCd:"",materialName:""
      }
    },

    materialFaces:[
      {
        faceCd:"",faceName:""
      }
    ],
    materialFaceMap:{
      "dummy":{
        faceCd:"",faceName:""
      }
    },

    equipments:[
      {
        equipmentCd:"",equipmentName:""
      }
    ],
    equipmentMap:{
      "dummy":{
        equipmentCd:"",equipmentName:""
      }
    },

    itemGroups:[
      {
        itemGroupCd:"",itemGroupName:""
      }
    ],
    itemGroupMap:{
       "dummy":{
        itemGroupCd:"",itemGroupName:""
      }, 
    },

    sizeItems:[
      {
        sizeCd:"",sizeName:"",unit:"",useRange:false
      }
    ],
    sizeItemMap:{
      "dummy":{
        sizeCd:"",sizeName:"",unit:"",useRange:false
      }
    },

    staffs:[
      {
        userId:0,accountName:"",staffCd:"",name:""
      }
    ],
    staffMap:{
      "dummy":{
        userId:0,accountName:"",staffCd:"",name:""
      }
    },

  },
  mutations: {

    // cognito user pool
    setUserPool(state,payload){
      state.cognito.userPool = payload;
    },

    setCurrentUser(state,payload){
      if (payload){
        state.currentUser.authenticated = true;
      } else {
        state.currentUser.authenticated = false;
      }
    },

    setProfile(state,payload){
      console.log("store setProfile",payload);
      state.userProfile.name = payload.name;
      state.userProfile.userId = payload.userId;

      /*
      {
          "companyCd": "mykk",
          "userId": "masaru_takahashi",
          "staffCd": "191",
          "name": "高橋 賢",
          "familyName": "高橋",
          "givenName": "賢",
          "mainGroupCd": "16",
          "groupCodes": [
              "16"
          ],
          "roleCodes": [
              "ROLECODE",
          ],
          "denyRoleCodes": [
              "ROLECODE"
          ],
          "avatarColor": "#4FC3F7",
          "avatarFileId": 18089
      }
      */
    },


    setStaffs(state,payload){

      console.log("store.setStaffs")
      console.log(payload)

      state.staffs.splice(0);

      Object.keys(state.staffMap).forEach(key => {
        Vue.delete(state.staffMap, key)
      })

      payload.forEach(rec => {
        let stf = {
          id:rec.id,
          staff_cd:rec.staff_cd,
          name:rec.name,
        };

        state.staffs.push(stf)
        Vue.set(state.staffMap, rec.id, stf)
      })

    },

    // 工程グループマスタの設定
    setProcessingsGroups(state,payload){

      console.log("store.setProcessingsGroups")
      console.log(payload)

      /*
       processings:{
        rootGroupTree:[     
          processGroups:[            
          ]
        ], 
      groups:[],
      groupMap:{},
      processMap:{},
    },

    processGroupCd: "PG1"
processGroupName: "表面処理"

"processGroupCd": "AS",
    "processGroupName": "組立その他",
    "processGroups": [
      {
        "processGroupCd": "AS01",
        "processGroupName": "組立その他",
        "processings": [],
        "sizeItems": []
      }
    ]


      */

      let sourceData = payload;

      let gpMap = {};
      let psMap = {}

      state.processings.rootGroupTree.splice(0);
      
      state.processings.groups.splice(0);
      Object.keys(state.processings.groupMap).forEach(key => {
        Vue.delete(state.processings.groupMap, key)
      })
      Object.keys(state.processings.processMap).forEach(key => {
        Vue.delete(state.processings.processMap, key)
      })

      sourceData.forEach(rootRec => {

        state.processings.rootGroupTree.push(rootRec);

        rootRec.processGroups.forEach(rec => {
            
          // 工程グループの登録
          state.processings.groups.push(rec);
          state.processings.groupMap[rec.processGroupCd] = rec;

          // 工程の登録
          rec.processings.forEach(p => {
            state.processings.processMap[p.processCd] = p;
          });

        });
        
      });

      console.log("state.processings")
      console.log(state.processings)

    },

    // 材料マスタ
    setMaterials(state,payload){

      console.log("store.setMaterials",payload)      

      state.materials.splice(0);

      Object.keys(state.materialMap).forEach(key => {
        Vue.delete(state.materialMap, key)
      })

      payload.forEach(rec => {
        state.materials.push(rec)
        Vue.set(state.materialMap, rec.materialCd, rec)
      })


    },
    // 母材形状
    setMaterialFaces(state,payload){
      console.log("store.setMaterialFaces",payload)      

      state.materialFaces.splice(0);
      Object.keys(state.materialFaceMap).forEach(key => {
        Vue.delete(state.materialFaceMap, key)
      })

      payload.forEach(rec => {
        state.materialFaces.push(rec)
        Vue.set(state.materialFaceMap, rec.faceCd, rec)
      })

    },
    // 保有生産設備
    setEquipments(state,payload){

      window.logger.log("store.setEquipments",payload)

      state.equipments.splice(0);
      Object.keys(state.equipmentMap).forEach(key => {
        Vue.delete(state.equipmentMap, key)
      })

      payload.forEach(rec => {
        state.equipments.push(rec)
        Vue.set(state.equipmentMap, rec.equipmentCd, rec)
      })

    },

    // 取扱品目
    setItemGroups(state,payload){

      window.logger.log("store.setItemGroups",payload)

      state.itemGroups.splice(0);
      Object.keys(state.itemGroupMap).forEach(key => {
        Vue.delete(state.itemGroupMap, key)
      })

      payload.forEach(rec => {
        state.itemGroups.push(rec)
        Vue.set(state.itemGroupMap, rec.itemGroupCd, rec)
      })

    },

    // 対応サイズ項目
    setSizeItems(state,payload){

      window.logger.log("store.setSizeItems",payload)

      state.sizeItems.splice(0);
      Object.keys(state.sizeItemMap).forEach(key => {
        Vue.delete(state.sizeItemMap, key)
      })

      payload.forEach(rec => {
        state.sizeItems.push(rec)
        Vue.set(state.sizeItemMap, rec.sizeCd, rec)
      })

    },

  },
  actions: {
  },
  modules: {
  }
})
